import { createAsyncThunk } from '@reduxjs/toolkit'
import { taskTrackerApi } from '../../api/taskTracker.api'
import type { TaskTrackerRecurringTaskSavePayload } from '../../lib/taskTrackerRecurringTasks.types'
import { getErrorMessage } from '../shared/thunk.utils'

export const fetchBoardRecurringTasksThunk = createAsyncThunk(
  'taskTracker/fetchBoardRecurringTasks',
  async (boardId: number, { rejectWithValue }) => {
    try {
      const items = await taskTrackerApi.listRecurringTasks(boardId)
      return { boardId, items }
    } catch (error: unknown) {
      return rejectWithValue({
        boardId,
        error: getErrorMessage(error, 'Не удалось загрузить регулярные задачи'),
      })
    }
  },
)

export const createBoardRecurringTaskThunk = createAsyncThunk(
  'taskTracker/createBoardRecurringTask',
  async (
    payload: { boardId: number; data: TaskTrackerRecurringTaskSavePayload },
    { rejectWithValue },
  ) => {
    try {
      const item = await taskTrackerApi.createRecurringTask(
        payload.boardId,
        payload.data,
      )
      return { boardId: payload.boardId, item }
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось создать регулярную задачу'),
      )
    }
  },
)

export const updateBoardRecurringTaskThunk = createAsyncThunk(
  'taskTracker/updateBoardRecurringTask',
  async (
    payload: {
      boardId: number
      recurringTaskId: number
      data: TaskTrackerRecurringTaskSavePayload
    },
    { rejectWithValue },
  ) => {
    try {
      const item = await taskTrackerApi.updateRecurringTask(
        payload.boardId,
        payload.recurringTaskId,
        payload.data,
      )
      return { boardId: payload.boardId, item }
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось сохранить регулярную задачу'),
      )
    }
  },
)

export const deleteBoardRecurringTaskThunk = createAsyncThunk(
  'taskTracker/deleteBoardRecurringTask',
  async (
    payload: { boardId: number; recurringTaskId: number },
    { rejectWithValue },
  ) => {
    try {
      await taskTrackerApi.deleteRecurringTask(
        payload.boardId,
        payload.recurringTaskId,
      )
      return payload
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось удалить регулярную задачу'),
      )
    }
  },
)
